import React, { useState } from "react";
import { Link } from 'react-router-dom';
import Typist from "react-typist";
import $ from 'jquery';
import Configs from "../../editable-stuff/configurations.json";

const Ppm = () => {
  const icons = Configs.icons;

  // const [backgroundType, setBackgroundType] = useState(Configs.backgroundType);
  const [hoverstatus, setHoverstatus] = useState([
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons"
  ]);

  $(function () {
    $('[data-toggle="tooltip"]').tooltip()
  })

  const toggleHover = data => {
    const newhoverStatus = [...hoverstatus];

    if (data.event === "enter") {
      newhoverStatus[data.icon.id] = "socialiconshover";
      return setHoverstatus(newhoverStatus);
    } else if (data.event === "leave") {
      newhoverStatus[data.icon.id] = "socialicons";
      return setHoverstatus(newhoverStatus);
    }
  };
  return (
    <div> 
      <div
        id="PpmHeader"
        className="jumbotron jumbotron-fluid bg-transparent bgstyle text-light min-vh-auto d-flex align-content-center align-items-center flex-wrap m-0"
      >
        <div className="container container-fluid text-center ">
          <h1 className="display-3">Polytechnic Playing Machine</h1>
          <Typist className="lead" cursor={{ hideWhenDone: true }}>
          The goal of the term project is to enhance a game project, named Polytechnic Playing Machine, PPM.</Typist>
          <div  style={{paddingTop: "20px"}}>
            <a
              className="btn btn-outline-light btn-lg"
              href="https://github.com/dannyjanani/Polytechnic-Playing-Machine"
              target="_blank"
              rel="noreferrer noopener"
              role="button"
              aria-label="Resume/CV"
            >
              Github Page
            </a>
          </div>
          <div className="p-6" style={{paddingTop:"20px", paddingBottom:"40px"}}>
            {icons.map(icon => (
              <a
                key={icon.id}
                target="_blank"
                rel="noopener noreferrer"
                href={icon.url}
                aria-label={`My ${icon.image.split("-")[1]}`}
              >
                <i
                  className={`fab ${icon.image}  fa-3x ${hoverstatus[icon.id]}`}
                  onMouseOver={() => toggleHover({ icon, event: "enter" })}
                  onMouseOut={() => toggleHover({ icon, event: "leave" })}
                />
              </a>
            ))}
          </div>
          <Link className="btn btn-outline-light btn-lg" role="button" to="/">Home</Link>
          &nbsp;&nbsp;&nbsp;
          <Link className="btn btn-outline-light btn-lg" role="button" to="/resume">Resume</Link>
          &nbsp;&nbsp;&nbsp;
          <Link className="btn btn-outline-light btn-lg" role="button" to="/projects">Projects</Link>
          {/* &nbsp;&nbsp;&nbsp;
          <Link className="btn btn-outline-light btn-lg" role="button" to="/vocals">Vocals</Link> */}
        </div>
      </div>
      <div id="Ppm" className="jumbotron jumbotron-fluid bg-transparent min-vh-100 m-0">
      <div className="container container-fluid p-5">
          <div className="accordion" id="PpmAccordian">
            <div className="card">
              <div className="card-header" id="PpmOverview">
                <h2 className="mb-0">
                  <button className="btn btn-lg btn-link" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne" style={{color:"black", fontWeight:"bold"}}>
                    Project Overview
                  </button>
                </h2>
              </div>

              <div id="collapseOne" className="collapse show" aria-labelledby="PpmOverview" data-parent="#PpmAccordian">
                <div className="card-body">
                  The Polytechnic Playing Machine, ppm, has three different versions. The ppm project to be enhanced is named machine vs. machine: ppmvsm. 
                  The other two versions of the ppm game at the course website are : (i) a human player playing against a machine player, human vs machine : ppmhvsm, and (ii) 
                  two human players play against each other, human vs human : ppmhvsh. 
                  <br></br><br></br>
                  The ppm players, human and machine, play digits on four position displays to earn points. They play the game until one wins the game. 
                  Then, the game is restarted by resetting. The players take turns to play : Player 1 plays, then Player 2 plays, then, Player 1 plays, etc. 
                  Always, Player 1 starts the game when the FPGA is downloaded or reset. Player 1 receives a pseudo-random digit (simply random digit, RD) to start with. 
                  Player 1 may choose to play the digit or skip the play. Whether Player 1 plays or skips, when Player 2 gets its turn it receives a new random digit. 
                  It may play the random digit or skip the play. If Player 2 skips the play, Player 1 gets a new random digit and has the same two options as before : play or skip. 
                  If a player skips a play no points are subtracted. Also, both players are allowed to see the next two random digits which can help them plan their moves better. 
                  In summary, the game for each player is about playing a random digit on a position display to earn points, more than the opponent. 
                  <br></br><br></br>
                  The random digit is a BCD digit, i.e. it is 0 through 9. Playing the random digit on a position display is either playing it directly (overwriting) or adding it to a display. 
                  If it is a direct play, the position is stored the random digit : RD. If it is an addition, the position is added the random digit and the result is placed on the same display. 
                  In either case, if the player has an adjacency, i.e. the digit played has an identical neighbor, the player earns more points. 
                  A 2-digit code which is not visible to the players and is on the rightmost two displays can help player earn even more points. 
                  <br></br><br></br>
                  The largest value to play on a display is F, i.e. 15 in decimal. That is, the sum of RD and the position display value cannot be greater than 15. 
                  If the sum exceeds 15, this situation is called display overflow. If the player plays it, the digit played is the sum minus 16. 
                  For example, if a position has E and RD is 9, after the addition the position is played 14 + 9 - 16 = 7. Then, the display blinks at a high rate, 
                  signalling there is a display overflow. If the player has an adjacency, the player earns more than 7 points. 
                  If the digit played is identical to the code digit on that position, the player earns additional points. 
                  Thus, winning the game is dependent on both chance and thinking. The ppm circuit is a digital system. 
                  A digital system consists of digital circuits. Today’s digital systems are numerous. Examples of digital systems are microprocessors, computers, DVD players and iPhones. 
                  They are also complex. Consequently, special emphasis is given to the coverage of digital systems in computer science and computer engineering curricula.
                  <br></br><br></br>
                  The ppm digital system consists of six blocks on six schematic sheets. Blocks 1, 2, 4, 5 and 6 are core blocks : They are already designed and 
                  provided with on schematics 1, 2, 4, 5 and 6. Block 3 on schematic 3 is the Machine Play Block and students will enhance it. Schematics 4 and 6 have black boxes or macros. 
                  Students cannot see their schematic implementations, but only VHDL ones. The machine vs machine or ppmmvsm project students enahnce has two 
                  additional schematic sheets to help student enhance their project better.
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="PpmGoals">
                <h2 className="mb-0">
                  <button className="btn btn-lg btn-link" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo" style={{color:"black", fontWeight:"bold"}}>
                    Project Goals
                  </button>
                </h2>
              </div>
              <div id="collapseTwo" className="collapse show" aria-labelledby="PpmGoals" data-parent="#PpmAccordian">
                <div className="card-body">
                  <ul style={{paddingLeft: "25px"}}>
                    <li>Teams of 4 plan and finalize how they will enhance ppmmvsm project.</li>
                    <li>Students may instead elect to develop their own project as long as the project involves a digital system.</li>
                    <li>The project follows the class coverage where the initial circuits are combinational circuits.</li>
                    <li>Blocks with sequential circuits are then designed.</li>
                    <li>We first describe the black box view of the ppm and then the individual blocks.</li>
                    <li>The descriptions are in the context of digital systems.</li>
                    <li>The description is also based on the <a href="https://www.digikey.com/products/en/development-boards-kits-programmers/evaluation-boards-embedded-complex-logic-fpga-cpld/796?k=digilent&k=410-292&pkeyword=digilent&sv=0&sf=0&FV=-8%7C796&quantity=&ColumnSort=0&page=1&pageSize=25" data-toggle="tooltip" title="" data-original-title="NEXYS A7 ECE FPGA TRAINER BOARD"> Digilent NEXYS-4 DDR FPGA board </a></li>
                    <li>Students will completely design Block 3 (the design of the machine player is left to students).</li>
                    <li>Students design its intelligence level and playing strategy.</li>
                    <li>The machine player plays according to the rules.</li>
                    <li>The machine vs. machine ppm project uses all eight displays and all 16 LED lights. </li>
                    <li>That is, four aditional displays and eight additional LED lights are used compared with the human vs. human and human vs. machine projects. </li>
                    <li>What is shown on these outputs is as follows:
                      <ul style={{paddingLeft: "25px"}}>
                        <li>Displays 4 and 5 show Player 1 points.</li>
                        <li>Displays 6 and 7 show Player 2 points.</li>
                        <li>LED lights 8 to 11 show the next random digit.</li>
                        <li>LED lights 12 to 15 show the following random digit.</li>
                      </ul>
                    </li>
                    <li>In addition, we will use the keypad and 7-Segment Pmods to enhance the game and debug the circuits faster. </li>
                    <li>Finally, students can input a random digit from switches SW15-SW12 to also debug their circuits faster.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="PpmGallery">
                <h2 className="mb-0">
                  <button className="btn btn-lg btn-link" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive" style={{color:"black", fontWeight:"bold"}}>
                    Gallery
                  </button>
                </h2>
              </div>
              <div id="collapseFive" className="collapse show" aria-labelledby="PpmGallery" data-parent="#PpmAccordian">
                <div className="card-body">
                <div className="row">
                    <div className="col-md">
                      <h5>Setup</h5>
                      <img src={require('./Media/ppm.JPG')} alt=""/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="PpmMaterials">
                <h2 className="mb-0">
                  <button className="btn btn-lg btn-link" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree" style={{color:"black", fontWeight:"bold"}}>
                    Provided Materials
                  </button>
                </h2>
              </div>
              <div id="collapseThree" className="collapse show" aria-labelledby="PpmMaterials" data-parent="#PpmAccordian">
                <div className="card-body" style={{minHeight:"0px"}}>
                  <ul style={{paddingLeft: "25px"}}>
                    <li>1x <a href="https://www.digikey.com/products/en/development-boards-kits-programmers/evaluation-boards-embedded-complex-logic-fpga-cpld/796?k=digilent&k=410-292&pkeyword=digilent&sv=0&sf=0&FV=-8%7C796&quantity=&ColumnSort=0&page=1&pageSize=25" data-toggle="tooltip" title="" data-original-title="NEXYS A7 ECE FPGA TRAINER BOARD">Digilent NEXYS-4 DDR FPGA board</a></li>
                    <li>1x <a href="https://www.digikey.com/products/en/switches/keypad-switches/202?k=14662&pkeyword=&sv=0&sf=0&FV=-8%7C202&quantity=&ColumnSort=0&page=1&pageSize=25" data-toggle="tooltip" title="" data-original-title="KEYPAD - 12 BUTTON">Keypad</a></li>
                    <li>1x <a href="https://www.adafruit.com/product/3108" data-toggle="tooltip" title="" data-original-title="4-Digit 7-Segment FeatherWing Display">7-Segment Pmods</a></li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-header" id="PpmUsage">
                <h2 className="mb-0">
                  <button className="btn btn-lg btn-link" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour" style={{color:"black", fontWeight:"bold"}}>
                    Skills Used
                  </button>
                </h2>
              </div>
              <div id="collapseFour" className="collapse show" aria-labelledby="PpmUsage" data-parent="#PpmAccordian">
                <div className="card-body">
                  <ul style={{paddingLeft: "25px"}}>
                    <li>Software:
                      <ul style={{paddingLeft: "25px"}}>
                        <li>Xilinx ISE</li>
                        <li>Schematic Design</li>
                        <li>VHDL</li>
                      </ul>
                    </li>
                    <li>Knowledge Acquired:
                      <ul style={{paddingLeft: "25px"}}>
                        <li>Number Systems</li>
                        <li>Combinational Circuits</li>
                        <li>Sequential Circuits</li>
                        <li>Programmable Components</li>
                        <li>Digital Systems</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Ppm;